module.exports = __webpack_public_path__ + "img/75659.4983f27e.svg";